<template>
    <div v-if="data">
        <van-popup v-model="shows" round position="bottom">
            <van-picker title="设定固定日期充值规则" item-height="100" :value="value" show-toolbar visible-item-count="5"
                :columns="columns" @confirm="onConfirm" @cancel="shows = false" />
        </van-popup>
        <van-tabs v-model="active" :color="'#5D5F63'">
            <!-- 交话费 start-->

            <van-tab title="交话费">
                <div class="input cost-form">
                    <input class="ipt" type="text" id="ipt" maxlength="11" placeholder="请输入手机号" @input="onInput"
                        readonly @click.stop="onMobilePhoneClick" v-model="phone" />
                    <em class="input-delete" @click="deleteHeadler">×</em>
                    <div class="history" v-if="isHistory && history != null">
                        <p @click="historyPhone(item)" v-for="(item, index) in history" :key="index">
                            {{ item }}
                        </p>
                    </div>
                    <span>请仔细核对充值号码，充错号将无法退款</span>
                    <p v-if="myMobilePhone && myMobilePhone == phone">
                        账户可用余额：<em>{{ data.balance }}元</em>
                    </p>
                </div>
                <ul class="rechar_list">
                    <li v-for="(vo, index) in cost" :class="{ rechar_active: rechar_li == index }" :key="index"
                        @click="rechar(index)">
                        {{ vo.cost }}
                    </li>
                    <li>
                        <input @blur="iptBlur()" @focus="iptFocus()" v-model="iptMoney" type="number" @input="iptMoney"
                            readonly @click.stop="onMoneyClick" />
                        <span id="placeholder">{{ placeholder }}</span>
                    </li>
                </ul>
                <van-button round type="info" :loading="checkingEligibility" :disabled="checkingEligibility"
                    loading-text="校验中" @click="callRecharge">立即充值</van-button>
                <Popup :show="show" panelClass="recharge-confirm-panel" @cancel="onCancel()"
                    @confirm="rechargeAddOrder()">
                    <div slot="conter" class="conter recharge-confirm-content">
                        <h3 class="recharge-confirm-title">确认充值信息</h3>
                        <p class="conter_phone">
                            <span>充值手机号</span><em>{{ phone }}</em>
                        </p>
                        <p class="conter_money">
                            <span>充值金额</span>
                            <em v-if="rechar_li != null">{{ cost[rechar_li].cost }}</em>
                            <em v-if="rechar_li == null">{{ iptMoney + "元" }}</em>
                        </p>
                        <div v-if="isLotteryEligible && lotteryContent" class="lottery-tip">
                            <strong>彩票选号权益</strong>
                            <span>{{ lotteryContent }}</span>
                        </div>
                    </div>
                </Popup>
            </van-tab>
            <van-tab title="自动充值" style="position: relative;">
                <div class="auto-recharge-form">
                    <span class="auto-recharge-text">手机号码：{{ phone }}</span>
                    <div class="auto-recharge   flex justify-between ">
                        <div class="auto-recharge-text">开通自动充</div>
                        <div class="auto-recharge-text">上月话费：<em>100元</em></div>
                    </div>
                </div>
                <div class="auto-recharge margin bg-transparent padding " style="font-weight: 500;">
                    <div class="auto-recharge-text flex justify-between margin-bottom">
                        <div>充值方式</div>
                        <div>定期定额 <van-icon name="arrow" /></div>
                    </div>
                    <div class="auto-recharge-text flex justify-between margin-bottom" @click="shows = true">
                        <div>充值日期</div>
                        <div><span style="color: #5D5F63;"> {{ value[0] ? value[0] : '建议每月5-25号' }}</span> <van-icon
                                name="arrow" />
                        </div>
                    </div>
                    <div class="auto-recharge-text flex justify-between margin-bottom" @click="shows = true">
                        <div>充值金额</div>
                        <div><span style="color: #5D5F63;"> {{ value[1] ? value[1] : '100元' }}</span> <van-icon
                                name="arrow" /></div>
                    </div>
                    <div class="auto-recharge-text flex justify-between  margin-bottom">
                        <div>扣款方式</div>
                        <div>微信支付<van-icon name="arrow" /></div>
                    </div>
                    <div class="auto-recharge-text flex justify-between margin-bottom" v-if="showPopup">
                        <div>上次更新时间</div>
                        <div style="margin-right: 40px;">2026-01-06</div>
                    </div>
                      <div class="auto-recharge-text flex justify-between margin-bottom" v-if="showPopup">
                        <div>状态</div>
                        <div style="margin-right: 40px;">已开通</div>
                    </div>
                </div>
                <div class="auto-recharge margin bg-transparent padding" v-if="!showPopup">
                    <div class="auto-recharge-text padding-bottom" style="border-bottom: 1px solid #E5E5E5;">
                        开通自动充需要向{{ phone }}进行短信验证</div>
                    <div class="auto-recharge-text padding-top flex justify-between align-center">
                        <div>短信验证码:</div>
                        <input @input="onInput" @click.stop="onMobilePhoneClick" style="flex:1;" type="text" id="ipt"
                            maxlength="4" placeholder="请输入验证码" v-model="code" />
                        <!-- <div @click="sendCode">获取验证码</div> -->
                        <button style="flex:1;" class="tab4_btn" :disabled="isNone" @click="submitRecharge">
                            {{ verifyCode }}
                        </button>
                    </div>
                </div>
                <div class="describe">
                    <ul>
                        <li>1.定期定额:系统按您选择的日期与金额，每月自动充值1次。</li>
                        <li>2.如何取消自动充值：点击页面“取消自动充值”按钮。即可取消。</li>
                        <li>3.微信如何解约扣款签约：[我-服务-钱包-支付设置-自动续费]关闭“蓝猫移动自动充值和扣费服务”</li>
                        <li>4.请注意，如您近期需将号码销户、过户等，请先取消自动充值并解约。</li>
                    </ul>
                </div>
                <div class="cancel-auto-recharge" style="">
                    <div @click="quitAutoRecharge">取消自动充</div>
                    <div>｜</div>
                    <div @click="goToAutoRechargeOrder">自动充值订单</div>
                </div>
                <van-button round type="info" @click="submitRecharge">{{ showPopup ? '提交修改' : '立即开通' }} </van-button>
            </van-tab>
            <!-- 交话费 end-->
            <van-tab title="充流量" v-if="flow">
                <div class="input" v-if="myMobilePhone">
                    <input class="ipt" type="text" id="ipt" maxlength="11" placeholder="请先绑定手机号" v-model="myMobilePhone"
                        disabled />
                    <div class="getCode">
                        <input type="text" maxlength="8" placeholder="请输入验证码" v-model="code" />
                        <button class="tab4_btn" :disabled="isNone" @click="codeHeadler">
                            {{ verifyCode }}
                        </button>
                    </div>

                    <load :load="load">
                        <p slot="text" class="loadText">短信发送中...</p>
                    </load>
                </div>
                <van-tabs class="Recharge-box" type="card" v-model="flowTabActive">
                    <van-tab title="流量加油包" v-if="data.traffic.code == '1'">
                        <ul class="rechar_list">
                            <li v-for="(item, index) in dayFlow" :class="{ rechar_active: dayFlow_li == index }"
                                :key="index" @click="flowClick(index, 'dayFlow')">
                                <p>{{ item.offerZname }}</p>
                                <p>{{ item.offerfee }}</p>
                            </li>
                        </ul>
                        <div class="describe">
                            <ul>
                                <li>1.流量加油包订购成功立即生效，支持重复订购:</li>
                                <li>2.必须已开通流量功能的用户才能可订购加油包;</li>
                                <li>3.订购后流量加油包当月有效次月自动失效；</li>
                                <li>4.流量充值费用将在您当前可用余额中扣除，请确保余额充足；</li>
                            </ul>
                        </div>
                        <van-button round type="info" @click="flowRecharge">立即充值</van-button>
                    </van-tab>

                    <van-tab title="流量月包">
                        <ul class="rechar_list">
                            <li v-for="(item, index) in monthFlow" :class="{
                                rechar_active: monthFlow_li == index,
                            }" :key="index" @click="flowClick(index, 'monthFlow')">
                                <p>{{ item.flow }}</p>
                                <p>{{ item.money }}</p>
                            </li>
                        </ul>
                        <div class="describe" v-html="data.monthFlow.desc"></div>
                        <van-button round type="info" @click="flowRecharge">立即充值</van-button>
                    </van-tab>
                </van-tabs>

                <Popup :show="show" confirmText="确认开通" @cancel="onCancel()" @confirm="openFlow()">
                    <div slot="conter" class="conter">
                        <p class="conter_phone">
                            <span>充值手机号:</span>
                            <em>{{ myMobilePhone }}</em>
                        </p>
                        <p class="conter_flow">
                            <span>流量包名称:</span>
                            <em>{{ flowPackageName }}</em>
                        </p>
                        <p class="conter_money">
                            <span>支付金额:</span>
                            <em>{{ flowPackagePrice }}</em>
                        </p>
                    </div>
                    <div class="bottom" slot="bottom">
                        流量包费用将在您当前可用余额中直接扣除
                    </div>
                </Popup>
            </van-tab>
        </van-tabs>

        <van-number-keyboard :value="phone" :show="numberKeyboardShow" @input="onNumberKeyboardInput"
            @delete="onNumberKeyboardDelete" @blur="onNumberKeyboardBlur" />
        <van-number-keyboard :value="iptMoney" :show="MoneyShow" @input="onMoneyInput" @delete="onMoneyDelete"
            @blur="onMoneyBlur" />
    </div>
</template>

<script>
import Vue from "vue"
import { mapState } from "vuex"
import API from "../../common/api/api"
import load from "../../components/load.vue"
import Popup from "../../components/Popup.vue"
import { Dialog, NumberKeyboard, Field, Toast } from "vant"
Vue.use(Toast).use(NumberKeyboard)
export default {
    name: "Recharge",
    data() {
        return {
            shows: false,
            iptMoney: "",
            active: 0,
            placeholder: "请输入10元及以上的金额",
            rechar_active: "rechar_active",
            rechar_li: null,
            dayFlow_li: null,
            monthFlow_li: null,
            show: false,
            checkingEligibility: false,
            isLotteryEligible: false,
            lotteryContent: "",
            phone: null,
            productId: "",
            myMobilePhone: "", //当前账号绑定的手机号
            balance: 0.0,
            cost: [],
            dayFlow: null,
            monthFlow: null,
            ordersId: null,
            payData: null,
            flowPackageName: "",
            flowPackagePrice: "",
            flowTabActive: 0,
            data: null,
            numberKeyboardShow: false,
            numberKeyboardBlurEvent: false,
            MoneyShow: false,
            MoneyBlurEvent: false,
            history: [],
            isHistory: false,
            code: "",
            flags: false,
            flow: false,
            show: false,
            value: ['', ''],
            showPopup: false,
        }
    },
    watch: {
        flowTabActive(newval) {
            if (newval == 1) {
                this.dayFlow_li = null
            } else {
                this.monthFlow_li = null
            }
            this.productId = null
        },
    },
    computed: {
        ...mapState(["member", "verifyCode", "isNone", "load"]),
        columns() {
            return [
                // 第一列
                {
                    className: 'day',
                    values: this.generateMonthDays(1, 28),
                    defaultIndex: 0,
                },
                // 第二列
                {
                    values: ['自动充20元', '自动充50元', '自动充100元', '自动充200元', '自动充500元'],
                    defaultIndex: 0,
                },
            ]
        }
    },
    components: {
        Popup,
        NumberKeyboard,
        Field,
        load,
    },
    created() {
        this.getRechargeProduct()
        let historyList = JSON.parse(localStorage.getItem("phoneList"))
        this.history = historyList

    },
    methods: {
        submitCancel() {
            Dialog.confirm({
                title: "取消自动充值功能",
                message: "是否取消自动充值功能？",
                confirmButtonText: "确认取消",
                cancelButtonText: "再想想",
            })
                .then(() => {
                    // on confirm
                    this.$router.replace("/")
                })
                .catch(() => {
                    // on cancel
                })
        },
        
        submitRecharge() {
            // Toast({
            //     message: "该功能暂未上线",
            //     position: "bottom",
            // })
            // return
            // if (this.productId == "") {
            //     Toast({
            //         message: "请选择流量包",
            //         position: "bottom",
            //     })
            //     return
            // }
            // if (this.iptMoney == "") {
            //     Toast({
            //         message: "请输入金额",
            //         position: "bottom",
            //     })
            //     return
            // }
            // if (this.code == "") {
            //     Toast({
            //         message: "请输入验证码",
            //         position: "bottom",
            //     })
            //     return
            // }
            Dialog.confirm({
                title: "自动扣费服务协议",
                message: "即将跳转至微信自动扣费签约页面（第三方应用），微信申请获取您的手机号用于自动扣费。请阅读并同意：<a href='https://www.baidu.com' target='_blank'>《自动扣费服务协议》</a>",
                confirmButtonText: "同意并继续",
                cancelButtonText: "拒绝",
            })
                .then(() => {
                    // on confirm
                    // this.$router.replace("/")
                    this.showPopup = true
                })
                .catch(() => {
                    // on cancel
                })

            this.$store.commit("recharge", {
                mobilePhone: this.myMobilePhone,
                productId: this.productId,
                amount: this.iptMoney,
                verifyCode: this.code,

            })

        },
        quitAutoRecharge() {
            Dialog.confirm({
                title: "取消自动充值功能",
                message: "是否取消自动充值功能？",
                confirmButtonText: "确认取消",
                cancelButtonText: "再想想",
            })
                .then(() => {
                    // on confirm
                    Toast({
                        message: "取消成功",
                        position: "bottom",
                    })
                    this.showPopup = false
                })
                .catch(() => {
                    // on cancel
                })
        },
        goToAutoRechargeOrder() {
            this.$router.push("/AutoRechargeOrder")
        },
        onConfirm(value) {
            this.value = value;
            this.shows = false;
        },
        sendCode() {
            if (this.flags) {
                return
            }
            this.flags = true
            setTimeout(() => {
                this.flags = false
            }, 60000)
        },
        //获取验证码
        codeHeadler() {
            let phone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if (this.myMobilePhone == "") {
                Toast({
                    message: "请输入手机号",
                    position: "bottom",
                })
            } else if (!phone.test(this.myMobilePhone)) {
                Toast({
                    message: "请输入正确的手机号",
                    position: "bottom",
                })
            } else {
                this.$store.commit("obtainCode", {
                    mobilePhone: this.myMobilePhone,
                    type: "07",
                })
            }
        },
        //历史记录
        historyPhone(phone) {
            this.phone = phone
            this.isHistory = false
        },
        //
        onMobilePhoneClick() {
            if (!this.numberKeyboardShow && !this.numberKeyboardBlurEvent) {
                this.numberKeyboardShow = true
                this.isHistory = true
            }
        },
        onMoneyClick() {
            if (!this.MoneyShow && !this.MoneyBlurEvent) {
                this.MoneyShow = true
            }
        },
        //键盘失去焦点
        onNumberKeyboardBlur() {
            this.numberKeyboardBlurEvent = true
            this.numberKeyboardShow = false
            setTimeout(() => {
                this.numberKeyboardBlurEvent = false
                this.isHistory = false
            }, 500)
        },
        onMoneyBlur() {
            this.MoneyBlurEvent = true
            this.MoneyShow = false
            setTimeout(() => {
                this.MoneyBlurEvent = false
            }, 500)
        },
        //键盘输入
        onNumberKeyboardInput(val) {
            if (this.phone.length < 11) {
                this.phone += val
            }
        },
        onMoneyInput(val) {
            if (this.iptMoney == "" && val == 0) {
                this.iptMoney = ""
            } else {
                this.iptMoney += val
            }
        },
        //键盘删除
        onNumberKeyboardDelete() {
            this.phone = this.phone.slice(0, -1)
        },
        onMoneyDelete() {
            this.iptMoney = this.iptMoney.slice(0, -1)
        },
        //获取充值产品
        getRechargeProduct() {
            API.getJson("RECHARGE_PRODUCT", {}).then(res => {
                if (res.serviceKind == 7) {
                    if (res.monthFlow.isShow == 1) {
                        this.flow = true
                    } else {
                        this.flow = false
                    }
                } else if (res.serviceKind == 8) {
                    this.flow = false
                }
                this.data = res
                this.cost = this.data.call.list
                this.dayFlow = this.data.traffic.list
                this.monthFlow = this.data.monthFlow.list
                this.myMobilePhone = this.data.mobilePhone
                this.myMobilePhone == "NULL" || this.myMobilePhone == "null" ?
                    this.phone = "" : this.phone = this.myMobilePhone
                this.balance = this.data.balance
                localStorage.setItem("phone", this.phone)
            })
        },
        //输入手机号
        onInput(e) {
            this.phone = this.phone.replace(/[^\d]/g, "")
        },
        onInputMoney(e) {
            this.iptMoney = this.iptMoney.replace(/[^\d]/g, "")
        },
        //开通流量
        openFlow() {
            this.show = false
            API.getJson("OPEN_FLOW", {
                productId: this.productId,
                code: this.code,
            }).then(res => {
                if (res.data) {
                    if (res.data.code == -100) {
                        Toast({
                            message: res.data.msg,
                            icon: "none",
                        })
                    }
                } else {
                    if (res.msg == "sucess") {
                        this.$router.push({ path: "/paySuccess" })
                    }
                }
            })
        },
        //话费充值下单
        rechargeAddOrder() {
            this.show = false
            let params = {
                mobilePhone: this.phone,
                rechargeNum: this.rechar_li == null ? this.iptMoney * 1 : this.cost[this.rechar_li].rechargeNum,
            }
            API.getJson("ADD_ORDERS", params).then(res => {
                this.ordersId = res.ordersId
                if (res.data) {
                    if (res.data.code == -100) {
                        Toast({
                            message: res.data.msg,
                            position: "bottom",
                        })
                    }
                } else {
                    if (res.ordersId != "") {
                        this.wechatOfficialAccountsPay()
                    }
                }
            })
        },
        //发起支付
        wechatOfficialAccountsPayInvoke(payData) {
            let that = this
            WeixinJSBridge.invoke("getBrandWCPayRequest", that.payData, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    console.log("支付成功")
                    let arr = []
                    arr.push(that.phone)
                    let phoneList = JSON.parse(localStorage.getItem("phoneList"))
                    if (phoneList == null || phoneList == "") {
                        console.log("判断储存没有的话")
                        localStorage.setItem("phoneList", JSON.stringify(arr))
                    } else {
                        // console.log("判断储存有的话")
                        if (phoneList.indexOf(arr) == -1) {
                            phoneList.push(arr[0])
                            localStorage.setItem("phoneList", JSON.stringify(phoneList))
                        } else {
                            console.log("该号码以储存")
                        }
                    }
                }
            }
            )
        },
        //公众号支付
        async wechatOfficialAccountsPay() {
            try {
                let res = await API.getJson("PAY", { ordersId: this.ordersId })
                this.payData = res.payData
                if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                        document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false)
                    } else if (document.attachEvent) {
                        document.attachEvent("WeixinJSBridgeReady", onBridgeReady)
                        document.attachEvent("onWeixinJSBridgeReady", onBridgeReady)
                    }
                } else {
                    this.wechatOfficialAccountsPayInvoke()
                }
            } catch (err) {
                console.log("公众号支付失败")
            }
        },
        //popup框取消回调
        onCancel() {
            this.show = false
        },
        //话费充值
        async callRecharge() {
            if (!/^1[3456789]\d{9}$/.test(this.phone)) {
                Toast({
                    message: "请输入正确的手机号",
                    position: "bottom",
                })
            } else if (
                this.rechar_li == null &&
                this.placeholder == "请输入10元及以上的金额"
            ) {
                Toast({
                    message: "请选择您要充值的金额",
                    position: "bottom",
                })
            } else if (this.rechar_li == null && this.iptMoney < 10) {
                Toast({
                    message: "请输入10元及以上的金额",
                    position: "bottom",
                })
            } else {
                if (this.checkingEligibility) return
                this.checkingEligibility = true
                try {
                    const amount = this.rechar_li == null
                        ? this.iptMoney
                        : this.cost[this.rechar_li].rechargeNum
                    const result = await API.getJson("LOTTERY_CHECK_ELIGIBILITY", {
                        phone: this.phone,
                        amount: String(amount),
                    }, false)
                    // API 封装仅在外层 code=1 时返回 data。
                    if (!result || !Object.prototype.hasOwnProperty.call(result, "islottery")) return
                    this.isLotteryEligible = Boolean(result.islottery)
                    this.lotteryContent = result.content || ""
                    this.show = true
                } catch (err) {
                    // 请求异常提示由统一 API 封装处理。
                } finally {
                    this.checkingEligibility = false
                }
            }
        },
        //流量日包、月包充值
        flowRecharge() {
            //如果为空 提示去绑定手机号
            if (!this.myMobilePhone) {
                Dialog.confirm({
                    title: "提示",
                    message: "您还未绑定手机号，无法使用流量充值服务",
                    confirmButtonText: "去绑定",
                })
                    .then(() => {
                        this.$router.push({ path: "/PersonalInformation" })
                    })
                    .catch(() => {
                        // on cancel
                    })
                //产品id
            } else if (!this.productId) {
                Toast({
                    position: "bottom",
                    message: "请选择流量套餐",
                })
            } else if (this.code == "") {
                Toast({
                    position: "bottom",
                    message: "请填写验证码",
                })
            } else if (!this.code) {
                Toast({
                    position: "bottom",
                    message: "验证码错误",
                })
            } else {
                this.show = true
            }
            // }else if(){

            //
        },

        //选择充值的话费
        rechar(index) {
            this.rechar_li = index
        },
        //选择日包、月包套餐
        flowClick(index, type) {
            this[type + "_li"] = index;
            const item = this[type][index];
            if (type == 'dayFlow') {
                this.productId = item.offerZid;
                this.flowPackageName = item.offerZname;
                this.flowPackagePrice = item.offerfee;
            } else if (type == 'monthFlow') {
                this.productId = item.id;
                this.flowPackageName = item.flow;
                this.flowPackagePrice = item.money;
            }
        },

        iptBlur() {
            if (this.iptMoney == "") {
                this.placeholder = "请输入10元及以上的金额"
            } else {
                this.placeholder = ""
            }
        },
        iptFocus() {
            this.placeholder = ""
            this.rechar_li = null
            this.productId = ""
            console.log(this.rechar_li)
        },
        //删除手机号
        deleteHeadler() {
            this.phone = ""
        },
        //生成每月日期数组
        generateMonthDays(start, end) {
            const days = []
            for (let i = start; i <= end; i++) {
                days.push(`每月${i}日`)
            }
            return days
        },
    },
}
</script>

<style lang="scss" scoped>
.box {
    height: 100vh;
    overflow: scroll;
}

.auto-recharge-form {}

.cancel-auto-recharge {
    text-align: center;
    justify-content: center;
    display: flex;
    font-size: px2rem(24);
    position: absolute;
    width: 100%;
    margin-top: px2rem(25);
    color: #8f9197
}

.flex {
    display: flex;
    align-items: center;
    justify-content: center;
}

.justify-center {
    justify-content: center;
}

.bg-transparent {
    background-color: #f6f6f6;
}

.justify-between {
    justify-content: space-between;
}

.auto-recharge {
    margin-top: px2rem(15);
}

.margin-tb {
    margin: px2rem(15) 0 px2rem(20) 0;
}

.margin-bottom {
    margin-bottom: px2rem(20);
}

.padding-bottom {
    padding-bottom: px2rem(15);
}

.padding-top {
    padding-top: px2rem(15);
}

.text-bold {
    font-weight: bold;
}

.padding {
    padding: px2rem(20);
}

.auto-recharge-text {
    font-size: px2rem(24);
    color: #333;
}

.auto-recharge-text .tab4_btn {
    padding: 0 px2rem(25);
    height: px2rem(50);
    line-height: px2rem(50);
    color: #fff;
    font-size: px2rem(24);
    background-color: #336289;
    text-align: center;
    border-radius: px2rem(20);
}

.getCode {
    position: relative;
    width: 100%;
    height: px2rem(100);
    background-color: #fff;
    font-size: px2rem(26);
    // padding: 0 px2rem(30);
    border-bottom: 1px solid #dfe0e7;
    box-sizing: border-box;
}

.getCode input {
    width: 100%;
    height: px2rem(100);
    font-size: px2rem(34);
    box-sizing: border-box;
}

.getCode .tab4_btn {
    position: absolute;
    right: px2rem(30);
    top: px2rem(25);
    padding: 0 px2rem(25);
    height: px2rem(50);
    line-height: px2rem(50);
    color: #fff;
    font-size: px2rem(24);
    background-color: #336289;
    text-align: center;
    border-radius: px2rem(20);
}

.history {
    position: absolute;
    left: 0;
    top: px2rem(202);
    width: 100%;
    max-height: px2rem(160);
    overflow-y: auto;
    background: #fff;
}

.history p {
    width: 100%;
    height: px2rem(80);
    line-height: px2rem(80) !important;
    color: #fff;
    font-size: px2rem(30) !important;
    padding: 0 px2rem(30);
    box-sizing: border-box;
    border-bottom: px2rem(1) solid #b5b5bb;
    margin: 0 !important;
}

.cost-form {
    position: relative;
}

.input .input-delete {
    position: absolute;
    right: px2rem(50);
    top: px2rem(20);
    color: #999;
    font-size: px2rem(50);
}

.ipt {
    width: 100%;
    height: px2rem(100);
    line-height: px2rem(100);
    font-size: px2rem(50);
    font-weight: bold;
    color: #333333;
    border-bottom: 1px solid #dfe0e7;
    letter-spacing: px2rem(2);
}

.ipt::placeholder {
    color: #333;
    font-size: px2rem(30);
    font-weight: normal;
}

.input span {
    font-size: px2rem(24);
    color: #909198;
}


.input p {
    font-size: px2rem(24);
    color: #333;
    line-height: px2rem(62);
    margin-bottom: px2rem(32);
}

.input p em {
    font-size: px2rem(26);
    color: #ff7505;
}

.rechar_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.rechar_list li {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    width: px2rem(170);
    height: px2rem(130);
    font-size: px2rem(26);
    border: 2px solid #abacb1;
    border-radius: px2rem(9);
    margin-bottom: px2rem(15);
    color: #5d5f64;
    font-weight: 600;
    margin-right: px2rem(15);
    box-sizing: border-box;
}

.rechar_list li input {
    position: absolute;
    width: px2rem(170);
    height: px2rem(88);
    font-size: px2rem(26);
    text-align: center;
    z-index: 9;
}

.rechar_list li #placeholder {
    position: absolute;
    width: px2rem(160);
    font-size: px2rem(24);
    color: #999;
    z-index: 8;
}

.rechar_list p {
    flex: 0 0 100%;
    line-height: 0.8rem;
}

.rechar_list p:nth-child(1) {
    margin-top: px2rem(5);
}

.rechar_list p:nth-child(2) {
    color: #ff7505;
    margin-top: px2rem(-20);
}

.van-button {
    width: 100%;
    height: px2rem(80);
    line-height: px2rem(80);
    color: #fff;
    font-weight: bold;
    font-size: px2rem(28);
    background-color: #336289;
    margin-top: px2rem(65);
    margin-bottom: px2rem(300);
    box-shadow: 0 0 px2rem(20) rgba(0, 0, 0, 0.3);
}

.van-tabs--card {
    margin-top: px2rem(30);
}

.describe {
    height: px2rem(270);
    margin-top: px2rem(32);
    overflow: scroll;
}

.describe ::v-deep li {
    font-size: px2rem(22);
    color: #8f9197;
    line-height: px2rem(48);
}

.rechar_active {
    color: #fff !important;
    background-color: #336289;
    box-shadow: 0 px2rem(5) px2rem(10) rgba(0, 0, 0, 0.3);
    border: none !important;
}

.rechar_list .rechar_active p {
    color: #fff;
}

.conter {
    margin-bottom: px2rem(30);
}

.conter p {
    display: flex;
    justify-content: space-between;
    padding: 0 px2rem(80);
    line-height: px2rem(56);
}

.conter p span {
    width: 50%;
    font-size: px2rem(26);
    color: #909198;
}

.conter p em {
    width: 50%;
    text-align: left;
    font-size: px2rem(28);
    color: #333;
    font-weight: 600;
}

.conter .conter_money em {
    color: #ff7505;
}

.conter .conter_flow em {
    color: #336289;
}

.conter .lottery-tip {
    margin: px2rem(16) px2rem(80) 0;
    padding: px2rem(14) px2rem(20);
    color: #d65a35;
    font-size: px2rem(25);
    line-height: 1.5;
    text-align: center;
    background: #fff4ec;
    border-radius: px2rem(8);
}

.recharge-confirm-content {
    margin-bottom: px2rem(34);
}

.recharge-confirm-title {
    margin: 0 0 px2rem(24);
    color: #1f2d3d;
    font-size: px2rem(32);
    font-weight: 600;
    line-height: px2rem(46);
    text-align: center;
}

.recharge-confirm-content p {
    min-height: px2rem(72);
    margin: 0 px2rem(48);
    padding: 0;
    align-items: center;
    line-height: normal;
    border-bottom: px2rem(1) solid #edf0f2;
}

.recharge-confirm-content p span,
.recharge-confirm-content p em {
    width: auto;
}

.recharge-confirm-content p span {
    color: #6f7882;
    font-size: px2rem(26);
}

.recharge-confirm-content p em {
    max-width: 65%;
    color: #202a33;
    font-size: px2rem(28);
    font-weight: 500;
    text-align: right;
    word-break: break-all;
}

.recharge-confirm-content.conter .conter_money em {
    color: #e76f24;
    font-size: px2rem(32);
    font-weight: 600;
}

.recharge-confirm-content.conter .lottery-tip {
    margin: px2rem(24) px2rem(48) 0;
    padding: px2rem(18) px2rem(20);
    color: #6f472d;
    text-align: left;
    background-color: #fff8f1;
    border: px2rem(1) solid #f3d8c2;
    border-left: px2rem(5) solid #e9833d;
    border-radius: px2rem(6);
}

.recharge-confirm-content .lottery-tip strong,
.recharge-confirm-content .lottery-tip span {
    display: block;
}

.recharge-confirm-content .lottery-tip strong {
    margin-bottom: px2rem(6);
    color: #b75220;
    font-size: px2rem(26);
    font-weight: 600;
    line-height: px2rem(36);
}

.recharge-confirm-content .lottery-tip span {
    color: #775847;
    font-size: px2rem(24);
    line-height: px2rem(38);
}

.bottom {
    width: 100%;
    height: px2rem(80);
    line-height: px2rem(80);
    font-size: px2rem(24);
    color: #909198;
    border-top: 1px solid #909198;
    text-align: center;
}
</style>
